import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSopSystemList = createAsyncThunk("fetchSopSystemList", async ({ page, limit }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: String(page),
		limit: String(limit),
	});

	const response = await axiosHttp.get(`/sop/list/sopsystem?${params}`, config);
	return response.data.data;
});

const SopSystemListSlice = createSlice({
	name: "SopSystemListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSopSystemList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSopSystemList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchSopSystemList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SopSystemListSlice.reducer;
